// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"EmptyPage_pattern-gradient__F6+Ur","box":"EmptyPage_box__3OsAD","icon":"EmptyPage_icon__H6m8E","title":"EmptyPage_title__SrxDk","text":"EmptyPage_text__IhqYO"};